import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as parametrosController from "../../../../../controllers/personasController/parametrosController";
import * as actions from "../../../../../store/modules/personas/parametros_store/actions";
import { Select } from "../../../../../components/Inputs/Input";
import SeletorIntegracao from "./components/SeletorIntegracao";
import { Col, FormGroup, Label } from "reactstrap";

const Parametros = () => {
  const { id_integracao, tipoIntegracao } = useSelector(
    (state) => state.personasParametros
  );
  const { tipoLoja } = useSelector((state) => state.personasPapeis);
  const { tab } = useSelector((state) => state.personas);

  useEffect(() => {
    if (tab === "7") {
      parametrosController.getTipoIntegracao();
      parametrosController.getParametrosDePara();
    }
  }, [tab]);

  useEffect(() => {
    if (tab === "7" && tipoLoja.id && id_integracao && id_integracao !== "0") {
      switch (id_integracao.toLowerCase()) {
        case "62f29e1b-7fd2-42b1-be17-7c716ab361bd":
          parametrosController.getCredencial(tipoLoja.id);
          break;
        case "dcc7d5ea-8b74-43df-9a32-061373b1308e":
        case "0d7b60a9-f267-439f-b3b9-7a7504feabec":
          parametrosController.GetByLojaId(tipoLoja.id, id_integracao);
          break;
        default:
          break;
      }
    }
  }, [tipoLoja.id, tab, id_integracao]);



  return (
    <>
      <Col style={{ margin: "25px 0 0 25px", padding: "0px" }}>
        <p style={{ fontSize: "18px", color: "var(--color-preto)" }}>
          Selecione a integração
        </p>
      </Col>
      <FormGroup style={{ width: "230px", margin: "25px 0 0 25px" }}>
        <Label for="integracoesSelect">Integrações</Label>
        <Select
          style={{ margin: "25px 0 0 25px" }}
          first="Selecione"
          value={{ value: id_integracao }}
          onChange={(e) => {
            actions.setTipoIntegracao(e.value);
          }}
          select={{ value: "id", label: "descricao" }} 
          options={tipoIntegracao} 
          isSearchable={true}
        />
      </FormGroup>

      <SeletorIntegracao id_integracao={id_integracao} />
    </>
  );
};

export default Parametros;
